﻿import React, { useState, useEffect } from 'react';
import { Document } from '../models/document';
import { AgilentRawDataFile } from '../models/Calculators/agilent-raw-data-file';
import { AgilentRawDataComponent } from '../models/Calculators/agilent-raw-data-component';
import SampleNameEntry from './SampleNameEntry';
import { LookupItem } from '../models/lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import DataGrid, {
    Column,
    Selection,
    Editing,
    Paging,
    Toolbar,
    HeaderFilter,
    FilterRow,
    Item as ToolBarItem,
    Button as ColumnButton,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    batchId: string;
    catalogNumber: string;
    batchName: string;
    onClose?: () => void;
}

export default function AgilentRawDataFileComponent(props: Props) {
    const [agilentData, setAgilentData] =
        useState<AgilentRawDataFile>();

    const [selectedComponent, setSelectedComponent] =
        useState<AgilentRawDataComponent>();

    const [samplePreparationTypes, setSamplePreparationTypes] =
        useState<LookupItem[]>();

    const [selectedSampleName, setSelectedSampleName] =
        useState<LookupItem>();

    const [sampleNameDialogVisible, setSampleNameDialogVisible] =
        useState<boolean>()

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">
                    <Button id="parseFileButton" text="Parse File" icon="importselected" type="success"
                        className="pw-button"
                        hint="parse file"
                        height={'1.8rem'}
                        onClick={onParseFileClick} />

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height={'1.8rem'}
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height={'1.8rem'}
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-two-column-grid">
                <div id="agilent-raw-data-components-datagrid-container" className="pw-datagrid">
                    <DataGrid
                        width="100%"
                        height="16rem"
                        dataSource={agilentData && agilentData.components ?
                            agilentData.components : []}
                        onSelectionChanged={onComponentsSelectionChanged}
                        onRowValidating={onComponentsValidating}
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        showBorders={true} >

                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <LoadPanel enabled={true} />

                        <Selection mode='single' />
                        <Paging enabled={false} />

                        <Column dataField='componentName' caption="Impurity"
                            cssClass="table-vertical-align" width='8rem' />

                        <Toolbar>
                            <ToolBarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Impurities</div>
                                </div>
                            </ToolBarItem>

                        </Toolbar>

                    </DataGrid>
                </div>

                <div id="agilent-raw-data-sample-types-datagrid-container" className="pw-datagrid">
                    <DataGrid
                        width="100%"
                        height="16rem"
                        dataSource={agilentData && agilentData.sampleTypes ?
                            agilentData.sampleTypes : []}
                        rowAlternationEnabled={true}
                         keyExpr="sampleTypeId"
                        showRowLines={true}
                        showBorders={true} >

                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        
                        <Selection mode='single' />
                        <Paging enabled={false} />

                        <Column dataField='rawSampleName' dataType='string'
                            cellRender={sampleNameItemRender}
                            allowEditing={false}
                            cssClass="table-vertical-align" width='12rem' />

                        <Column dataField='cleanedSampleName' dataType='string'
                            cssClass="table-vertical-align" width='12rem' />

                        <Column dataField='isSelected' caption="Include" dataType='boolean'
                            cssClass="table-vertical-align" width='6rem' />

                        <Column />

                        <Editing mode="cell"
                            useIcons={true}
                            allowAdding={false}
                            allowUpdating={true}
                            allowDeleting={false} />

                        <Toolbar>
                            <ToolBarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Sample Types</div>
                                </div>
                            </ToolBarItem>
                        </Toolbar>
                    </DataGrid>
                </div>
            </div>

            <div id="agilent-raw-data-values-datagrid-container" className="pw-datagrid">
                <DataGrid
                    width="100%"
                    height="26rem"
                    dataSource={selectedComponent && selectedComponent.values ?
                        selectedComponent.values : []}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true} >

                    {/*
                    onSelectionChanged={onComponentsSelectionChanged}
                    onRowValidating={onComponentsValidating}
                    */}

                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <LoadPanel enabled={true} />

                    <Selection mode='single' />
                    <Paging enabled={false} />

                    {/*
                    <Column name="bc0" type="buttons" width='4rem'>
                        <ColumnButton hint="delete" icon="trash"
                            onClick={onAnalysisDataRowRemoving} />
                        <ColumnButton hint="certificate" icon="info"
                            onClick={onAnalysisDatumInfoButtonClick} />
                    </Column>
                    */}

                    {/*
                    <Column width='2rem' cssClass="table-vertical-align"
                        cellRender={editMarkerCellRender} />

                    <Column dataField={'elution'} dataType="number"
                        cssClass="table-vertical-align"
                        alignment='center' width='6rem' />

                    <Column dataField={'rawMaterialName'} cssClass="table-vertical-align"
                        cellRender={componentActualRawMaterialRender}
                        allowEditing={false} width='25rem' />

                    <Column name="bc1" type="buttons" width="2rem" cssClass="table-vertical-align">
                        <ColumnButton hint="lookup raw material" icon="find"
                            onClick={onLookupRawMaterialClick} />
                    </Column>
                    */}

                    <Column dataField='rawSampleName' dataType="string"
                        allowEditing={false} cellRender={sampleNameItemRender}
                        cssClass="table-vertical-align" width='12rem' />

                    <Column dataField='cleanedSampleName' dataType="string"
                        cssClass="table-vertical-align" width='12rem' />

                    <Column name="bc0" type="buttons" width="2rem" cssClass="table-vertical-align">
                        <ColumnButton hint="sample names" icon="find"
                            onClick={onSampleNameLookupClick} />
                    </Column>

                    <Column dataField='injectionOrder' dataType="number"
                        cssClass="table-vertical-align" width='12rem' />

                    <Column dataField='numberOfInjections' caption="# Injections" dataType="number"
                        cssClass="table-vertical-align" width='12rem' />
                        
                    <Column dataField='retentionTime' dataType="number"
                        allowEditing={false} width='10rem'
                        cssClass="table-vertical-align" />

                    <Column dataField='peakArea' dataType="number"
                        allowEditing={false} width='10rem'
                        cssClass="table-vertical-align" />

                    <Column dataField='peakHeight' dataType="number"
                        allowEditing={false} width='10rem'
                        cssClass="table-vertical-align" />

                    <Column />

                    <Editing mode="cell"
                        useIcons={true}
                        allowAdding={false}
                        allowUpdating={true}
                        allowDeleting={false} />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Samples</div>
                            </div>
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button type='success' icon="tags"
                                width='2.1rem' hint="Correct sample names"
                                onClick={correctSampleNames} />
                        </ToolBarItem>

                    </Toolbar>
                </DataGrid>
            </div>

            {sampleNameDialogVisible &&
                <DialogPopup key={`sn${key}`}
                    visible={sampleNameDialogVisible}
                    onHiding={hideSampleNameDialog}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    title="Sample Name Entry"
                    width='50rem'
                    height='38rem'>
                    <SampleNameEntry samplePreparationTypes={samplePreparationTypes}
                        sampleName={selectedSampleName && selectedSampleName.name ?
                            selectedSampleName.name : undefined}
                        onCancel={hideSampleNameDialog}
                        onApplySelection={applySampleName} />
                </DialogPopup>
            }

            <input type="file"
                id="fileInputElement"
                accept=".xls,.xlsx"
                className="file-picker-input"
                value=""
                onChange={onFileLoaderChange} />
        </div>
    );

    function onSampleNameLookupClick(e: any) {
        console.log("onSampleNameLookupClick");
        console.log(e);

        //if (e.row && e.row.data)
        //  setSelectedPreparation(e.row.data);

        setSampleNameDialogVisible(true);
    }

    function applySampleName(name: string) {


    }

    function onParseFileClick() {
        fileLoaderClick();
    }

    async function onSaveClick() {
        if (agilentData) {
            await saveAgilentRawDataFile(agilentData);
        }
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    function correctSampleNames() {
        let correctedData = { ...agilentData };

        for (let component of correctedData.components) {
            for (let datum of component.values) {

                let cleanedSampleName = findProperSampleName(datum.rawSampleName);
                datum.cleanedSampleName = cleanedSampleName;
            }
        }

        setAgilentData(correctedData);
    }

    function findProperSampleName(rawSampleName: string) {
        //move this to server side

        if (rawSampleName.includes("Check"))
            return rawSampleName.replace("Check", "CK");

    }

    function onComponentsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedComponent(e.selectedRowsData[0]);
        }
    }

    function onComponentsValidating(e: any) {


    }

    /*
    function validateSampleNames(agilentRawData: AgilentRawDataFile): AgilentRawDataFile {

        if (!samplePreparationTypes) {
            //message user
            return agilentRawData;
        }

        let validatedData = { ...agilentRawData };

        for (let component of validatedData.components) {
            for (let datum of component.values) {

                let matchingSamplePrepType = samplePreparationTypes.find(t => t.name === datum.rawSampleName);

                if (!matchingSamplePrepType)
                    datum.invalidSampleName = true;
            }
        }

        return validatedData;
    }
    */

    async function getAgilentData() {
        await CrudFunctions.getData(`calculator/agilentrawdata/${props.batchId}`)
            .then((data) => {
                console.log("agilent raw data");
                console.log(data);

                setAgilentData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function getSamplePreparationsTypes() {
        await CrudFunctions.getData("common/sampletypes")
            .then((data) => {
                setSamplePreparationTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Sample Preparations Types");
            });
    }

    async function parseAgilentRawDataFile(doc: any) {
        await CrudFunctions.postData(`calculator/parseagilentrawdatafile/${props.batchId}`, doc)
            .then((data) => {
                console.log("returned Agilent raw data");
                console.log(data);

                setAgilentData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Parsing Agilent Raw Data File");
            })
    }

    async function saveAgilentRawDataFile(rawData: AgilentRawDataFile) {
        await CrudFunctions.postData("calculator/agilentrawdata", rawData)
            .then((data) => {
                //todo add toast                
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Saving Agilent Raw Data File");
            })
    }    

    async function getAllData() {
        await Promise.all([
            //getAgilentData(),
            getSamplePreparationsTypes()
        ]);
    }

    //file functions

    function fileLoaderClick() {
        const fileElem = document.getElementById("fileInputElement") as HTMLInputElement;

        if (fileElem)
            fileElem.click();
    }

    async function onFileLoaderChange(e: any) {
        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            let doc: Document = {
                name: file.name,
                kbSize: file.size,
                mimeTypeString: file.type
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(doc, event)
                .then((doc) => {
                    parseAgilentRawDataFile(doc);
                });

            reader.readAsBinaryString(file);
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let documentData = btoa(binaryString);

            doc.base64Blob = documentData;
            return doc;
        }
    }

    //show/hide

    function hideSampleNameDialog() {
        setSampleNameDialogVisible(false);
    }

    //render

    function sampleNameItemRender(e: any) {
        if (e.data) {

            let css = "valid-data ";
            if (e.data.invalidSampleName)
                css = "invalid-data";

            return (
                <div className={css}>{e.data.rawSampleName}</div>
            );
        }
        else
            return (<div></div>);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}